import styled from 'styled-components';

import {LanguageSelector} from 'components/common/LanguageSelector';
import {Button} from 'components/ui-kit/Button';
import {DrawerCloseButton} from 'components/ui-kit/Sidebar/close-button';
import {colors, breakpoint} from 'theme';

export const SidebarContent = styled.div`
    display: flex;
    flex-flow: column nowrap;
    height: 100%;
`;

export const SidebarHeader = styled.div`
    display: flex;
    flex-flow: column wrap;

    ${DrawerCloseButton} {
        margin-right: 40px;

        @media (min-width: ${breakpoint.tablet}) {
            margin-right: 24px;
        }
    }
`;

export const LogoContainer = styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
`;

export const LogoutButton = styled(Button)`
    font-size: 16px;
    font-weight: 500;
    color: ${colors.brandPrimary};
    text-decoration: none;

    @media (min-width: ${breakpoint.tablet}) {
        font-size: 12px;
    }
`;

export const Language = styled(LanguageSelector)`
    justify-self: center;
    align-self: center;
    margin-top: 10px;
    transform: scale(1.2);
`;

export const Search = styled.div`
    margin-top: 40px;
    margin-bottom: 10px;

    @media (min-width: ${breakpoint.tablet}) {
        display: none;
    }
`;
